<mat-form-field appearance="outline">
  <mat-label>{{ label() }}</mat-label>
  <input
    matInput
    [formControl]="control()"
    [minlength]="11"
    [maxlength]="11"
    (keydown)="onKeyDown($event)"
    (input)="onInputChange()"
    type="tel"
    inputmode="numeric"
    [readonly]="readOnly()"
  />

  @if (control().value && isClear()) {
    <button matSuffix mat-icon-button aria-label="Clear" (click)="clear()">
      <mat-icon>close</mat-icon>
    </button>
  }

  <!-- <mat-error
    *ngIf="control().hasError('minlength') || control().hasError('maxlength')"
    [ngClass]="{'error-margin': control().hasError('minlength') || control().hasError('maxlength')}">
    El CUIT/CUIL debe tener exactamente 11 dígitos.
  </mat-error> -->
</mat-form-field>
